import { Button } from "antd";
import React, { useContext, useEffect, useState } from "react";

import { AuthContext } from "./../index";
import ViewPDF from "./viewPDFinternal";
import MDCompanyInfo from "../modalnotification/mdCompanyInfo";

import Apdung from "../assets/apdung.svg";
import Banner from "../assets/banner.svg";
import Doituong from "../assets/doituong.svg";
import IntroCondition from "../assets/intro-condition.svg";
import IntroConditionEdited from "../assets/intro-condition-edited-v2.svg";
import IntroProcedure from "../assets/intro-procedure.svg";
import Quyenloi from "../assets/quyenloi.svg";
import Slider from "../assets/slider.svg";

const Introduce = () => {
  const { goStep } = useContext(AuthContext);
  const [isOpen, setisOpen] = useState(false);
  const [url, setUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [openCompanyInfo, setOpenCompanyInfo] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  return (
    <div
      style={{
        fontSize: 14,
        textAlign: "center",
        background: "#ffffff",
        width: "100%",
      }}
    >
      <ViewPDF
        title={title}
        isOpen={isOpen}
        url={url}
        onClose={() => setisOpen(!isOpen)}
      />
      <MDCompanyInfo
        open={openCompanyInfo}
        handleCancel={() => setOpenCompanyInfo(false)}
      />
      <img style={{ width: "100%" }} src={Banner} alt="Banner" />
      <div style={{ height: 7, background: "#F7F7F7" }}></div>
      <div style={{ overflowX: "auto", margin: "5% 4%" }}>
        <img
          style={{ width: "auto", whiteSpace: "nowrap" }}
          src={Slider}
          alt="Banner"
        />
      </div>
      <div style={{ padding: "10px 0px" }}>
        <img style={{ width: "76%" }} src={Quyenloi} alt="Banner" />
      </div>
      <div style={{ padding: "10px 0px 10px 0px" }}>
        <img style={{ width: "91%" }} src={Doituong} alt="Banner" />
      </div>
      <div style={{ padding: "10px 0px 30px 0px" }}>
        <img style={{ width: "91%" }} src={Apdung} alt="Banner" />
      </div>
      <div style={{ height: 8, background: "#F7F7F7" }}></div>
      <img
        onClick={() => {
          setisOpen(!isOpen);
          setUrl("https://cdn.globalcare.vn/private/pdf/tomato/bhv-rule/quy-tac-tai-nan.pdf");
          setTitle("Điều kiện, điều khoản");
        }}
        style={{ width: "100%", cursor: "pointer" }}
        src={IntroCondition}
        alt="IntroCondition"
      />
      <img
        onClick={() => setOpenCompanyInfo(true)}
        style={{ width: "100%", cursor: "pointer" }}
        src={IntroConditionEdited}
        alt="IntroConditionEdited"
      />
      <div style={{ background: "#F7F7F7" }}>
        <img
          style={{ width: "100%", paddingTop: 10 }}
          src={IntroProcedure}
          alt="IntroProcedure"
        />
      </div>{" "}
      <div style={{ height: 80, background: "#F7F7F7" }}></div>
      <div className="footer">
        <Button onClick={() => goStep(2)} className="main-btn">
          Tiếp tục
        </Button>
      </div>
    </div>
  );
};

export default Introduce;
